import React from "react";

import { Stop } from "../../types/app.types";

interface CapacityChartProps {
  stops: Stop[];
  totalSeats: number;
  showPercentage: boolean;
  onToggleMode: (showPercentage: boolean) => void;
}

export const CapacityChart: React.FC<CapacityChartProps> = ({
  stops,
  totalSeats,
  showPercentage,
  onToggleMode,
}) => {
  if (stops.length === 0) {
    return null;
  }

  const renderYAxisLabels = () => {
    if (showPercentage) {
      return (
        <>
          <div className="y-axis-label">100%</div>
          <div className="y-axis-label">75%</div>
          <div className="y-axis-label">50%</div>
          <div className="y-axis-label">25%</div>
          <div className="y-axis-label">0%</div>
        </>
      );
    }

    const step = Math.ceil(10);
    return (
      <>
        <div className="y-axis-label">{totalSeats}</div>
        <div className="y-axis-label">{step * 3}</div>
        <div className="y-axis-label">{step * 2}</div>
        <div className="y-axis-label">{step}</div>
        <div className="y-axis-label">0</div>
      </>
    );
  };

  return (
    <div className="detail-card capacity-card">
      <div className="capacity-card-header">
        <h4>📊 Заповненість по сегментам</h4>
        <div className="capacity-toggle-container">
          <button
            className={`capacity-mode-btn ${showPercentage ? "active" : ""}`}
            onClick={() => onToggleMode(true)}
          >
            Відсотки
          </button>
          <button
            className={`capacity-mode-btn ${!showPercentage ? "active" : ""}`}
            onClick={() => onToggleMode(false)}
          >
            Місця
          </button>
        </div>
      </div>

      <div className="capacity-chart-container">
        <div className="bar-chart-wrapper">
          <div className="bar-chart-y-axis">
            {renderYAxisLabels()}
            <div className="y-axis-line"></div>
          </div>

          <div className="bar-chart">
            {stops.map((stop: Stop, index: number) => {
              const occupiedCount = stop.occupied_seat_count;
              const percentage =
                totalSeats > 0
                  ? Math.round((occupiedCount / totalSeats) * 100)
                  : 0;

              const barHeight =
                totalSeats > 0 ? (occupiedCount / totalSeats) * 100 : 0;

              return (
                <div key={index} className="bar-chart-item">
                  <div className="bar-container">
                    <div
                      className="bar-fill"
                      style={{ height: `${barHeight}%` }}
                      title={`${occupiedCount}м/${percentage}%`}
                    ></div>
                  </div>
                  <div className="bar-label" title={stop.stop_name}>
                    <span>{stop.stop_name}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
